import { render, staticRenderFns } from "./LiveDetails.vue?vue&type=template&id=70b30c87&scoped=true"
import script from "./LiveDetails.vue?vue&type=script&lang=ts"
export * from "./LiveDetails.vue?vue&type=script&lang=ts"
import style0 from "./LiveDetails.vue?vue&type=style&index=0&id=70b30c87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b30c87",
  null
  
)

export default component.exports